function pad(n){return (n<10?"0":"")+n;}
function tick(){
  document.querySelectorAll("[data-countdown]").forEach(function(c){
    var launchValue=c.getAttribute("data-launch")||"2026-07-23T09:00:00-04:00";
    var LAUNCH=new Date(launchValue).getTime();
    if(isNaN(LAUNCH)){LAUNCH=new Date("2026-07-23T09:00:00-04:00").getTime();}
    var d=LAUNCH-Date.now();
    if(d<=0){c.innerHTML='<div class="cd-live">It&rsquo;s here. Early access is open. Check your inbox! 🎉</div>';return;}
    var dd=Math.floor(d/864e5),hh=Math.floor(d%864e5/36e5),mm=Math.floor(d%36e5/6e4),ss=Math.floor(d%6e4/1e3);
    c.querySelectorAll("[data-days]").forEach(function(e){e.textContent=pad(dd);});
    c.querySelectorAll("[data-hours]").forEach(function(e){e.textContent=pad(hh);});
    c.querySelectorAll("[data-mins]").forEach(function(e){e.textContent=pad(mm);});
    c.querySelectorAll("[data-secs]").forEach(function(e){e.textContent=pad(ss);});
  });
}
tick();setInterval(tick,1000);
function syncHeroImage(){
  document.querySelectorAll(".reveal-wrap").forEach(function(wrap){
    var grid=wrap.closest(".hero-grid"),copy=grid&&grid.querySelector(".hero-copy");
    if(!copy)return;
    wrap.style.width="";
  });
}
syncHeroImage();
window.addEventListener("resize",syncHeroImage);
window.addEventListener("load",syncHeroImage);
var __canHover=window.matchMedia&&window.matchMedia("(hover: hover) and (pointer: fine)").matches;
document.querySelectorAll(".reveal").forEach(function(r){
  if(__canHover){
    r.addEventListener("mouseenter",function(){r.classList.add("peeking");});
    r.addEventListener("mouseleave",function(){r.classList.remove("peeking");});
  }
  r.addEventListener("click",function(){r.classList.toggle("peeking");});
  r.addEventListener("keydown",function(e){if(e.key==="Enter"||e.key===" "){e.preventDefault();r.classList.toggle("peeking");}});
});
var stick=document.getElementById("stick"),hero=document.querySelector(".hero");
if(stick&&hero){var so=new IntersectionObserver(function(es){es.forEach(function(en){stick.classList.toggle("show",!en.isIntersecting);});},{threshold:0});so.observe(hero);}
var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add("in");io.unobserve(en.target);}});},{threshold:.15});
document.querySelectorAll(".rise").forEach(function(el){io.observe(el);});
var fio=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add("in");fio.unobserve(en.target);}});},{threshold:.4});
document.querySelectorAll("[data-fuel]").forEach(function(el){fio.observe(el);});
document.querySelectorAll("form.kl-waitlist").forEach(function(f){
  f.addEventListener("submit",function(e){
    e.preventDefault();
    var input=f.querySelector("input[type=email]");
    var email=input?input.value.trim():"";
    if(!email){return;}
    var company=f.getAttribute("data-kl-company");
    var list=f.getAttribute("data-kl-list");
    var btn=f.querySelector("button[type=submit]");
    var original=btn?btn.textContent:"";
    if(btn){btn.disabled=true;btn.textContent="Joining…";}
    var payload={data:{type:"subscription",attributes:{custom_source:"Evolve Waitlist LP",profile:{data:{type:"profile",attributes:{email:email}}}},relationships:{list:{data:{type:"list",id:list}}}}};
    fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+encodeURIComponent(company),{
      method:"POST",
      headers:{"Content-Type":"application/json","revision":"2024-10-15"},
      body:JSON.stringify(payload)
    }).then(function(r){
      if(r.ok){
        var s=f.querySelector(".signup");if(s){s.classList.add("hide");}
        var ok=f.querySelector(".success");if(ok){ok.classList.add("show");}
      }else{
        if(btn){btn.disabled=false;btn.textContent=original;}
        if(input){input.setAttribute("aria-invalid","true");}
      }
    }).catch(function(){
      if(btn){btn.disabled=false;btn.textContent=original;}
    });
  });
});
